import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { AddressZipcodeResponse } from 'domains/change-cadastral.d';

export const getAddressByZipCode: QueryFunction<AddressZipcodeResponse> = async ({
  queryKey: [zipcode],
}) => {
  return (await api
    .get('address/zipcode/search', { params: { zipCode: zipcode } })
    .then((resp) => resp)) as unknown as AddressZipcodeResponse;
};
